<template>
  <div>
    <div class="needPay" v-if="status == 1">
      <div class="flexCenter text">
        <img src="@/assets/img/timeIcon.png" alt="" class="timeIcon">待付款
      </div>
      <div class="resTime">
        订单剩余时长 {{orderInfo.rocallTime}}
      </div>
    </div>
    <div  v-if="status == 3 || status == 4">
      <div class="address-link" v-if="logistics.length > 0" @click="goLogistics">
        <div class="flexOne material">
          <div>{{logistics[0].context}}</div>
          <div class="materialTime">{{logistics[0].ftime}}</div>
        </div>
        <img src="@/assets/img/arrow.png" alt="" class="arrow addressArrow">
      </div>
      <div class="address-link" v-else>
        <div class="flexOne material">
          <div class="commonBox-title">暂无物流信息</div>
        </div>
      </div>
    </div>
    <div  v-if="status == 5">
      <div class="address-link" v-if="logistics.length > 0" @click="goLogistics">
        <div class="flexOne material">
          <div>{{logistics[0].context}}</div>
          <div class="materialTime">{{logistics[0].ftime}}</div>
        </div>
        <img src="@/assets/img/arrow.png" alt="" class="arrow addressArrow">
      </div>
      <div class="address-link commonBox-title" v-else>
        <div class="flexOne material">
          <div class="commonBox-title">暂无物流信息</div>
        </div>
      </div>
    </div>
<!--    <div class="" v-if="status == 1 || status == 2">-->
    <div class="" v-if="status == 1">
      <div class="">
        <div class="address-link">
          <div class="address">
            <div v-if="isHasAddress" class="">
              <div class="nowAddress">
                <span>{{orderInfo.orders[0].consigneeFullAddress}}</span>
              </div>
              <div class="name">
                <span>{{orderInfo.orders[0].consigneeName}} {{orderInfo.orders[0].consigneeMobile}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="van-clearfix">
          <ul v-if="orderInfo.orders.length > 0">
            <li v-for="(item, index) in orderInfo.orders" :key="index" class="goods-list" :class="(orderInfo.orders.length == 1)  ? 'noMargin noRadiuShadow' : ''">
              <div class="shopDetail">
                <img  v-if="item.orderItems[0].sellerLogo" :src="baseImg + item.orderItems[0].sellerLogo" alt="" class="shopLogo">
                <img v-else src='@/assets/img/iv_placeholder_Center@2x.png' class="shopLogo" />
                {{item.orderItems[0].sellerName}}
  <!--              {{item.shopName}}-->
              </div>
              <div class="commonPro" v-for="(itemWrap,indexWrap) in item.orderItems" @click="goDetail(itemWrap)">
                <div class="common_proImg">
                  <img :src="baseImg + itemWrap.goodsThumbnail" alt="">
                </div>
                <div class="common_detail">
                  <div class="common_pro_name">{{itemWrap.goodsName}}</div>
                  <div class="common_pro_detail">
                    <div class="common_pro_sku">
                      <!--                  {{item.sku}}-->
                    </div>
                  </div>
                  <div class="pro_priceNum">
                    <div class="pro_value"><span class="pro_unit">￥</span><span>{{itemWrap.salesPrice | integerPrice}}</span><span class="pro_decimals">.{{itemWrap.salesPrice | decimalsPrice}}</span></div>
                    <div class="flexCenter num">
                      X{{itemWrap.quantity}}
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
          <div class="goods-list-static"  :class="(orderInfo.orders.length == 1)  ? 'noRadiu' : ''">
            <div class="commonBox">
              <div class="commonBox-title">订单编号:</div>
              <div class="commonBox-value">{{orderInfo.no}}</div>
            </div>
            <div class="commonBox">
              <div class="commonBox-title">下单时间:</div>
              <div class="commonBox-value">{{orderInfo.createTime}}</div>
            </div>
            <div class="commonBox">
              <div class="commonBox-title">商品总额</div>
              <div class="commonBox-value red">￥{{orderInfo.paymentAmount}}</div>
            </div>
            <div class="sum">
              <div class="borderSum">
                <div class="commonBox-title"></div>
                <div class="commonBox-value">合计：<span class="red">￥<span class="red">{{orderInfo.paymentAmount}}</span></span></div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="address-link">
        <div class="address">
          <div class="">
            <div class="nowAddress">
              <span>{{orderInfo.consigneeFullAddress}}</span>
            </div>
            <div class="name">
              <span>{{orderInfo.consigneeName}} {{orderInfo.consigneeMobile}}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="van-clearfix">
        <ul v-if="orderInfo.orderItems.length > 0">
<!--          <li v-for="(item, index) in orderInfo.orders" :key="index" class="goods-list" :class="(orderInfo.orders.length == 1)  ? 'noMargin noRadiuShadow' : ''">-->
          <li class="goods-list" :class="(orderInfo.orderItems.length == 1)  ? 'noMargin noRadiuShadow' : ''">
            <div class="shopDetail">
              <img  v-if="orderInfo.orderItems[0].sellerLogo" :src="baseImg + orderInfo.orderItems[0].sellerLogo" alt="" class="shopLogo">
              <img v-else src='@/assets/img/iv_placeholder_Center@2x.png' class="shopLogo" />
              {{orderInfo.orderItems[0].sellerName}}
<!--              {{item.shopName}}-->
            </div>
            <div class="commonPro" v-for="(itemWrap,indexWrap) in orderInfo.orderItems"  @click="goDetail(itemWrap)">
              <div class="common_proImg">
                <img :src="baseImg + itemWrap.goodsThumbnail" alt="">
              </div>
              <div class="common_detail">
                <div class="common_pro_name">{{itemWrap.goodsName}}</div>
                <div class="common_pro_detail">
                  <div class="common_pro_sku">
                    <!--                  {{item.sku}}-->
                  </div>
                </div>
                <div class="pro_priceNum">
                  <div class="pro_value"><span class="pro_unit">￥</span><span>{{itemWrap.salesPrice | integerPrice}}</span><span class="pro_decimals">.{{itemWrap.salesPrice | decimalsPrice}}</span></div>
                  <div class="flexCenter num">
                    X{{itemWrap.quantity}}
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>
        <div class="goods-list-static"  :class="(orderInfo.length == 1)  ? 'noRadiu' : ''">
          <div class="commonBox">
            <div class="commonBox-title">订单编号:</div>
            <div class="commonBox-value">{{orderInfo.no}}</div>
          </div>
          <div class="commonBox">
            <div class="commonBox-title">下单时间:</div>
            <div class="commonBox-value">{{orderInfo.createTime}}</div>
          </div>
          <div class="commonBox">
            <div class="commonBox-title">商品总额</div>
            <div class="commonBox-value red">￥{{orderInfo.paymentAmount}}</div>
          </div>
          <div class="sum">
            <div class="borderSum">
              <div class="commonBox-title"></div>
              <div class="commonBox-value">合计：<span class="red">￥<span class="red">{{orderInfo.paymentAmount}}</span></span></div>
            </div>

          </div>
        </div>
      </div>
    </div>




    <div class="ocupie"></div>
    <div class='comm_f_box' v-if="status == 1 || status == 2">
      <div class='flexOne price' v-if="status == 1">
        <div class="allValue" v-if="!showDelet">合计：<span class="pro_unit">￥<span>{{orderInfo.paymentAmount}}</span></span></div>
      </div>
      <div v-if="status == 1" class="allFlexCenter">
        <div class='heightBtn' @click.stop='cacerBoxPop'>取消订单</div>
        <div class='heightBtn active' @click.stop='linkPay'>立即支付</div>
      </div>
      <div v-if="status == 2" class="flexCenter" style="width: 100%">
        <div class='heightBtn active long s_long' @click.stop='reAddCart(orderInfo.id)'>再次购买</div>
      </div>
    </div>
    <div class='common-box flexCenter' v-if="status == 3 || status == 4" style="background: #fff">
      <div class='buyAgain' @click="isSureGet()" v-if="isGetGoods">确认收货</div>
      <div :class='isGetGoods ? "buyAgain active" : "common-btn"' @click.stop='reAddCart(orderInfo.id)'>再次购买</div>
    </div>
    <div class='common-box' v-if="status == 5" style="background: #fff">
      <div class='common-btn' @click.stop='reAddCart(orderInfo.id)'>再次购买</div>
    </div>
    <van-popup
      v-model="showGoods"
      position="bottom">
      <div class="popGoodsTitle">
        是否确认收货
      </div>
      <div class="goodsBtn">
        <div class="flexCenter" style="width: 100%">
          <div class='heightBtn long borderActive' @click.stop='showGoods = false'>取消</div>
          <div class='heightBtn active long' @click.stop='linkPay'>确定</div>
        </div>
      </div>
    </van-popup>
    <van-popup
      v-model="showCancerBox"
      position="bottom">
      <div class="popGoodsTitle">
        是否要取消订单
      </div>
<!--      <van-field-->
<!--        v-model="message"-->
<!--        rows="2"-->
<!--        autosize-->
<!--        label="取消原因"-->
<!--        type="textarea"-->
<!--        maxlength="50"-->
<!--        placeholder="请输入取消原因"-->
<!--        show-word-limit-->
<!--      />-->
      <div class="goodsBtn">
        <div class="flexCenter" style="width: 100%">
          <div class='heightBtn long borderActive' @click.stop='showCancerBox = false'>取消</div>
          <div class='heightBtn active long' @click.stop='cacerOrder'>确定</div>
        </div>
      </div>
    </van-popup>
    <van-popup
      v-model="showBox"
      position="bottom">
      <div class="popGoodsTitle">
        是否确认收货
      </div>
      <div class="goodsBtn">
        <div class="flexCenter" style="width: 100%">
          <div class='heightBtn long borderActive' @click.stop='showBox = false'>取消</div>
          <div class='heightBtn active long' @click.stop='getGoods'>确定</div>
        </div>
      </div>
    </van-popup>
    <van-popup
      v-model="waysShow"
      position="bottom">
      <div class="wayTitle">
        选择支付方式
      </div>
      <div class="wayContent">
        <div class="ways" @click="chooseWays(1)">
          <div class="flexCenter">
            <img src="@/assets/img/alipay.png" alt="" class="wayIcon">
            支付宝
          </div>
          <div class='select-box'>
            <img src='@/assets/img/chooseArrow.png' v-if="payWays == 1" />
          </div>
        </div>
        <div class="ways" style="border:none" @click="chooseWays(2)">
          <div class="flexCenter">
            <img src="@/assets/img/weChat.png" alt="" class="wayIcon">
            微信
          </div>
          <div class='select-box'>
            <img src='@/assets/img/chooseArrow.png' v-if="payWays == 2" />
          </div>
        </div>
      </div>
      <div class="payBtn" @click="transferPay">
        支付：￥{{orderInfo.paymentAmount}}
      </div>
    </van-popup>
  </div>
</template>
<script>
import { setToken, getToken } from 'utils/auth.js'
import EnvionmentVariables from '../../../../baseUrl'
import { formatPrice, linkApp, browserEnvironment, isWeixin } from 'utils/index'
const wx = require('weixin-js-sdk');
export default {
  name: 'shopCart',
  components: {

  },
  data () {
    return {
      payWays: '',
      show: false,
      timeNum: '1599459018',
      isHasAddress: true,
      residueTime: "2020-10-19 16:30:00",
      shopName: "携康自营店",
      showGoods: false,
      orderId: '',
      paymentOrderId: '',
      orderInfo: {
        orders: [{
          consigneeFullAddress: '',
          consigneeMobile: '',
          consigneeName: '',
          orderItems: [{
            sellerLogo: '',
            sellerName: ''
          }]
        }],
        orderItems: [{
          sellerLogo: '',
          sellerName: ''
        }],
        rocallTime: '00:00:00',
        paymentWay: ""
      },
      baseImg: EnvionmentVariables.IMAGE_HOST,
      showDelet: false,
      showCancerBox: false,
      logistics: [{
        context: '',
        ftime: ''
      }],
      showBox: false,
      isGetGoods: true,
      isWx: isWeixin(),
      waysShow: false,
      from: ''
    }
  },
  beforeCreate () {
    document.querySelector('body').setAttribute('style', 'background-color:#f7f5f5;');
  },
  created () {
    // 获取订单分页列表：订单状态：1待付款2已取消3待发货4待收货5已完成6已退款
    var that = this;
    var token = this.$route.query.appToken;
    if (token) {
      setToken(token);
    }
    var from = this.$route.query.from; // from 存在从支付页面跳到详情页  1单个商品下单  2 购物车下单  3 已有订单 重新支付
    if (from) {
      this.from = from
    }
    this.orderId = this.$route.query.orderId;
    this.paymentOrderId = this.$route.query.paymentOrderId;
    this.status = this.$route.query.status;
    if (this.status == 1) {
      // countdown(this.residueTime, '', function (res) {
      //   that.rocallTime = res;
      //   that.$forceUpdate();
      // });
    } else if (this.status == 2){
      document.title = '已取消'
    } else if (this.status == 3 || this.status == 4){
      document.title = '待收货'
      this.getLogisticsTracking();
    } else if (this.status == 5){
      document.title = '已完成';
      this.getLogisticsTracking();
    } else if (this.status == 6){
      document.title = '已退款';
      // this.getLogisticsTracking();
    }
    this.getOrderDetails();
  },
  mounted () {
    // debugger
  },
  methods: {
    isSureGet (item, orderIndex) {
      this.showBox = true;
    },
    // 确定收货
    getGoods () {
      var that = this;
      var param = {
        service: "appagg",
        query: {
          id: this.orderInfo.id
        }
      }
      this.$api.receiveGoods(param).then(res => {
        if (res) {
          if (res.data.basis.status === 200) {
            that.$toast("操作成功");
            this.isGetGoods = false
            this.showBox = false;
          }
        }
      })
    },
    // 再次购买
    reAddCart (orderId) {
      var that = this;
      var param = {
        service: "appagg",
        query: {
          orderId: orderId
        }
      }
      this.$api.reCreate(param).then(res => {
        if (res) {
          if (res.data.basis.status === 200) {
            that.$toast("操作成功");
            setTimeout(function () {
              that.$router.push({ path:'/shopCart', query: {}});
            },1000)
          }
        }
      })
    },
    goDetail (item) {
      this.$router.replace({ path:'/goodDetails', query: { id: item.goodsId} });
    },
    goLogistics () {
      this.$router.push({ path:'/logistics', query: {id: this.orderId}});
    },
    showActionSheet () {
      this.show = true
    },
    // app 支付，有订单号
    linkPay () {
      var that = this;
      if (this.isWx) {
        console.log("isWx");
        this.goApplet()
      }else{
        this.waysShow = true;
      }
    },
    // 安卓 ios 重新支付
    transferPay () {
      var param = {
        service: "appagg",
        query: {
          paymentOrderId: this.orderInfo.id,
          paymentWay: this.payWays
        }
      }
      this.$api.appPay(param).then(res => {
        if (res) {
          if (res.data.basis.status === 200) {
            this.alipay(res.data.result.parameters);
          }
        }
      })
    },
    // 下单在小程序端
    goApplet () {
      console.log("goApplet");
      let that = this
      let options = {
        token: getToken(),
        appletHasToken: () => {
          console.log("小程序跳转");
          let xcxUrl = `/pages/pay/pay?paymentOrderId=${this.orderInfo.id}&from=3`
          wx.miniProgram.navigateTo({ url: xcxUrl })
        },
        appletNoToken: () => {
          console.log("小程序跳转");
          let xcxUrl = `/pages/pay/pay?paymentOrderId=${this.orderInfo.id}&from=3`
          wx.miniProgram.navigateTo({ url: xcxUrl })
        },
        weiXinHasToken: () => {
        },
        weiXinNoToken: () => {
        },
        iphoneHasToken: () => {

        },
        iphoneNoToken: () => {

        },
        androidHasToken: () => {

        },
        androidNoToken: () => {

        },
        browserHasToken: () => {
        },
        browserNoToken: () => {
        }
      };
      browserEnvironment(options)
    },
    alipay (payParameters, orderId) {
      let that = this
      let options = {
        token: getToken(),
        appletHasToken: () => {
        },
        appletNoToken: () => {
        },
        weiXinHasToken: () => {
        },
        weiXinNoToken: () => {
        },
        iphoneHasToken: () => {
          let appParams = {
            payWays: this.payWays,
            paymentOrderId: this.paymentOrderId,
            payParameters: payParameters
          }
          linkApp(appParams, '', appParams.pageType)
        },
        iphoneNoToken: () => {
          let appParams = {
            payWays: this.payWays,
            paymentOrderId: this.paymentOrderId,
            payParameters: payParameters
          }
          linkApp(appParams, '', appParams.pageType)
        },
        androidHasToken: () => {
          let appParams = {
            payWays: this.payWays,
            paymentOrderId: this.paymentOrderId,
            payParameters: payParameters
          }
          linkApp(appParams, '', appParams.pageType)
        },
        androidNoToken: () => {
          let appParams = {
            payWays: this.payWays,
            paymentOrderId: this.paymentOrderId,
            payParameters: payParameters
          }
          linkApp(appParams, '', appParams.pageType)
        },
        browserHasToken: () => {
        },
        browserNoToken: () => {
        }
      };
      browserEnvironment(options)
    },
    chooseWays (payWays) {
      this.payWays = payWays;
    },
    buyAgain () {
      this.$router.push({ path:'/confirmOrder', query: {}});
    },
    chooseAddress () {
      this.$router.push({ path:'/addressManage', query: {}});
    },
    cacerBoxPop () {
      this.showCancerBox = true;
    },
    // 获取物流
    getLogisticsTracking () {
      var that = this;
      var param = {
        service: "appagg",
        query: {
          id: this.orderId
        }
      }
      this.$api.getLogisticsTracking(param).then(res => {
        if (res) {
          if (res.data.basis.status === 200) {
            this.logistics = res.data.result.data;
            if (!this.logistics) {
              this.logistics = []
            }
          }
        }
      })
    },
    cacerOrder () {
      // 取消订单
      var that = this;
      var param = {
        service: "appagg",
        query: {
          paymentOrderId: this.paymentOrderId,
          reason: ''
        }
      }
      this.$api.cancelOrder(param).then(res => {
        if (res) {
          if (res.data.basis.status === 200) {
            this.$toast("取消成功");
            setTimeout(function (res) {
              that.$router.push({ path:'/order', query: {}});
            },1000)
          }
        }
      })
    },
    // 获取订单详情
    getOrderDetails () {
      // 1待付款2已取消3待发货4待收货5已完成6已退款
      var that = this;
      // if (this.status == 1 || this.status == 2) {
      if (this.status == 1) {
        var param = {
          service: "appagg",
          query: {
            id: this.paymentOrderId
          }
        }
        this.$api.getPaymentOrderByPaymentOrderId(param).then(res => {
          if (res) {
            if (res.data.basis.status === 200) {
              this.orderInfo = res.data.result;
              that.computetTime(this.orderInfo, 0, this.orderInfo.currentTime ,this.orderInfo.createTime);
            }
          }
        })
      } else {
        var param = {
          service: "appagg",
          query: {
            id: this.orderId
          }
        }
        this.$api.getByOrderId(param).then(res => {
          if (res) {
            // if (res.data.basis.status === 200) {
            //   this.orderInfo = res.data.result;
            // }
            this.orderInfo = res.data.result;
            if (this.orderInfo.orderItems){
              this.orderInfo.createTime =  this.orderInfo.orderItems[0].createTime
            }
          }
        })
      }

      // var param = {
      //   service: "appagg",
      //   query: {
      //     id: this.paymentOrderId
      //   }
      // }
      // this.$api.getPaymentOrderByPaymentOrderId(param).then(res => {
      //   if (res) {
      //     if (res.data.basis.status === 200) {
      //       this.orderInfo = res.data.result;
      //       that.computetTime(this.orderInfo, 0, this.orderInfo.currentTime , this.orderInfo.createTime);
      //     }
      //   }
      // })

    },
    computetTime (item, index, nowTime, createTime) {
      var that = this;
      var ct = createTime.replace(/\-/g, '/'); // 创建订单时间
      var st = nowTime.replace(/\-/g, '/'); // 服务器当前时间
      var ts = new Date(st).getTime();
      var tc = new Date(ct).getTime();
      var cm = (30 * 60 * 1000 - (ts - tc))/1000;
      var timerIndex = "timer" + index;
      timerIndex = setInterval(()=>{
        cm-= 1
        that.runBack(item,cm)
        if (cm < 1) {
          item.rocallTime = '00:00:00'
          clearInterval(timerIndex)
          that.orderList.splice(index,1)
        }
      },1000)
    },
    runBack (item,cm) {
      var min = parseInt(cm/60);
      min = min > 9 ? min : `0${min}`
      let sec = parseInt(cm % 60);
      sec = sec > 9 ? sec : `0${sec}`
      item.rocallTime = `00:${min}:${sec}`
      this.$forceUpdate();
    },

  },
  destroyed () {
    console.log("商品详情 Detail")
    wx.miniProgram.postMessage({ data: {title: '商品详情'} })
  },
  // beforeRouteLeave (to, from, next) {
  //   // 设置下一个路由的meta
  //   to.meta.keepAlive = false // 不缓存，即刷新
  //   next(vm => {
  //     console.log("11111111111")
  //     vm.$router.replace({ path: '/shopCart', query: {} });
  //   })
  // }
}
</script>

<style scoped lang="less">
  /deep/ .commonPro{
    margin: 10px 0;
  }
  .payBtn{
    width: 532px;
    height: 80px;
    line-height: 80px;
    text-align: center;
    background: #FF3E29;
    border-radius: 8px;
    margin:60px auto 40px;
    font-size: 32px;
    font-weight: 400;
    color: #FFFFFF;
  }
  .ways{
    font-size: 32px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #3E3E3E;
    border-bottom: 2px solid rgba(208, 214, 230, 0.3);
    padding: 24px 0;
  }
  .wayContent{
    width: 100%;
    /*padding: 0 40px;*/
    box-sizing: border-box;
  }
  .wayIcon{
    width: 50px;
    height: 50px;
    margin-right: 38px;
  }
  .wayTitle{
    color: #3E3E3E;
    font-size: 36px;
    margin-top: 36px;
    text-align: center;
    margin-bottom: 76px;
  }
  /deep/ .common_pro_name{
    padding-top: 6px;
  }
  .buyAgain{
    width: 262px;
    height: 64px;
    line-height: 64px;
    color: #3E3E3E;
    font-size: 24px;
    margin: 0 15px;
    text-align: center;
    border: 2px solid #3E3E3E;
    border-radius: 8px;
  }
  .buyAgain.active{
    background: #FF3E29;
    border: 2px solid #FF3E29;
    color: #fff;
  }
  .name > span{
    font-size: 24px;
  }
  .heightBtn.long.s_long{
    width: 80%;
  }
  .orderCancerBtn{
    margin-top: 60px;
    padding-bottom: 50px;
  }
  .goodsBtn{
    padding-bottom: 104px;
  }
  .popGoodsTitle{
    padding-top: 70px;
    padding-bottom: 84px;
    font-size: 32px;
    color: #3E3E3E;
    text-align: center;
  }
  .materialTime{
    margin-top: 14px;
    font-size: 29px;
  }
  .material{
    color: #3E3E3E;
    font-size: 32px;
    line-height: 1.3;
  }
  .goods-list-static.noRadiu{
    border-radius:0 0 12px 12px;
    box-shadow: 0px 0px 0px transparent;
  }
  .goods-list-static.noRadiu .boxPart{
    border-top: none;
  }
  .goods-list.noMargin{
    margin-bottom: 0px;
  }
  .goods-list.noRadiuShadow{
    border-radius: 12px 12px 0 0;
    box-shadow: 0px 0px 0px transparent;
  }
  .paddingBorder{
    padding: 32px 0;
    border-bottom:2px solid rgba(208, 214, 230, 0.3);
  }
  .pro_list li:last-child .paddingBorder{
    border: none;
  }
  /deep/ .van-popup--bottom{
    border-radius: 12px 12px 0px 0px;
    min-height: 300px;
    padding: 32px 32px 0px;
    box-sizing: border-box;
  }
  .popTitle{
    color: #3E3E3E;
    font-size: 36px;
    text-align: center;
    font-weight: bold;
  }
  .btn{
    width: 180px;
    height: 64px;
  }
  .comm_f_box{
    box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.16);
  }
  .pro_unit{
    font-weight: bold;
    font-size: 36px;
  }
  .borderSum{
    width: 100%;
    border-top: 2px solid rgba(208, 214, 230, 0.31);
    padding: 28px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .sum{
    padding:0px 32px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 32px;
    background: #fff;
  }
  .commonBox-value{
    color: #3E3E3E;
    font-size: 29px;
    font-weight: bold;
  }
  .commonBox-title{
    color: #B1B1B2;
    font-size: 29px;
  }
  .num{
    color: #B1B1B2;
    font-size: 29px;
  }
  .ocupie{
    height: 202px;
    width: 100%;
  }
  .static{
    color: #3E3E3E;
    font-size: 24px;
    width: 152px;
    height: 148px;
    transform: translateX(32px);
    background: url("../../../assets/img/all_num_bg.png") no-repeat;
  }
  .morePro{
    width: 148px;
    height: 148px;
    margin-right: 32px;
    float: left;
  }
  .morePro:nth-child(3){
    margin-right: 0;
  }
.resTime{
  font-size: 29px;
  color: #FFF;
  text-align: center;
  width: 100%;
  font-weight: bold;
  margin-top: 48px;
}
.text{
  color: #fff;
  font-size: 40px;
  font-weight: bold;
}
.timeIcon{
  width: 40px;
  height: 40px;
  margin-right: 18px;
}
.needPay{
  padding: 98px 0;
  background: linear-gradient(91deg, #FF202B 0%, #FF4E20 100%);
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.1);
}
.select-box img{
  width: 38px;
  height: 38px;
  display: inline-block;
  vertical-align: middle;
}
.select-box{
  width: 38px;
  height: 38px;
  border-radius: 100%;
  -webkit-border-radius: 100%;
  -moz-border-radius: 100%;
  -ms-border-radius: 100%;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -ms-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  display: inline-block;
  margin-right: 10px;
}
.allValue{
  color: #3E3E3E;
  font-size: 29px;
}
.f-box .price{
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  margin-left: 80px;
  padding-top:32px;
  color: #393939;
  font-size: 28px;
}
.f-box{
  position: fixed;
  width: 100%;
  left: 0;
  bottom: 0;
  background-color: #fff;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  -ms-box-sizing: border-box;
  border-top: 1px solid #ddd;
}
.commonBox{
  padding:32px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 32px;
  background: #fff;
}
.priceDive{
  color: red;
}
.detail > div{
  margin-bottom: 20px;
}
.detail{
  flex: 1;
  font-size: 32px;
}
.proImg{
  width: 170px;
}
.proImg > img{
  width: 150px;
  height: 150px;
  display: block;
}
.liDivWrap{
  width: 100%;
  display: flex;
  border-bottom: 1px solid #f7f5f5;
}
.liDiv{
  display: flex;
  padding: 0 20px;
}
//.liDiv > div{
//  margin-bottom: 10px;
//  font-size: 32px;
//  display: flex;
//  padding: 10px 20px;
//  box-sizing: border-box;
//}
.priceNum{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.goods-list{
  width: 100%;
  background: #fff;
  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.08);
  opacity: 1;
  border-radius: 12px;
  padding: 32px;
  box-sizing: border-box;
  margin-bottom: 32px;
}
.address-link{
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  background-color: #fff;
  padding:30px;
  align-items: center;
  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.08);
  border-radius: 0px 0px 12px 12px;
  /*border-radius: 12px 12px 12px 12px;*/
  margin-bottom: 32px;
}
.address{
  font-size: 26px;
  flex: 1;
}
.noAddress{
  color: #999;
}

</style>
